<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <div class="hotel_name_style" v-if="hotel_name">
        <div class="hotel_name_style_left">
          <img
            src="@/icons/hotel_name.png"
            style="width: 16px; height: 16px;"
          />
          {{ hotel_name }}
        </div>

        <div
          class="connect_list"
          v-if="can_connect == 1"
          @click="openSwitchHotelDialog"
        >
          切换
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <div class="line_style"></div>
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <div>你好，{{ name }}</div>
          <!-- <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar"> -->
          <i class="el-icon-caret-bottom" />
        </div>

        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <!-- <a target="_blank" href="https://github.com/PanJiaChen/vue-admin-template/">
            <el-dropdown-item>Github</el-dropdown-item>
          </a>
          <a target="_blank" href="https://panjiachen.github.io/vue-element-admin-site/#/">
            <el-dropdown-item>Docs</el-dropdown-item>
          </a> -->
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 切换酒店弹窗 -->
    <el-dialog
      title=""
      :visible.sync="switchHotelDialogVisible"
      width="560px"
      :show-close="true"
      custom-class="switch_hotel_dialog"
      :append-to-body="true"
      :close-on-click-modal="true"
    >
      <div slot="title" class="switch_hotel_dialog_title">
        <div class="switch_hotel_dialog_title_main">切换酒店</div>
        <div class="switch_hotel_dialog_title_sub">
          选择需要操作的酒店门店后点击确认
        </div>
      </div>

      <div class="switch_hotel_list">
        <div
          v-for="hotel in hotelList"
          :key="hotel.hotel_no"
          :class="{
            switch_hotel_item: true,
            switch_hotel_item_active: selectedHotelNo === hotel.hotel_no
          }"
          @click="selectedHotelNo = hotel.hotel_no"
        >
          <div class="switch_hotel_item_icon">
            <i class="el-icon-school"></i>
          </div>
          <div class="switch_hotel_item_info">
            <div class="switch_hotel_item_name">{{ hotel.hotel_name }}</div>
            <!-- <div class="switch_hotel_item_addr">
              <i class="el-icon-location-outline"></i>
              {{ hotel.hotel_address }}
            </div> -->
          </div>
          <div class="switch_hotel_item_check">
            <i
              v-if="selectedHotelNo === hotel.hotel_no"
              class="el-icon-check"
            ></i>
            <div v-else class="switch_hotel_item_radio"></div>
          </div>
        </div>
      </div>

      <div slot="footer" class="switch_hotel_dialog_footer">
        <div class="switch_hotel_dialog_footer_tip">
          单击选项高亮，确认后即刻生效
        </div>
        <div class="switch_hotel_dialog_footer_btns">
          <el-button
            class="switch_hotel_btn_cancel"
            @click="switchHotelDialogVisible = false"
            >取消</el-button
          >
          <el-button
            class="switch_hotel_btn_confirm"
            :disabled="!selectedHotelNo"
            @click="confirmSwitchHotel"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { apiPostAdminAccountBindswitch } from "@/api/user.js";
import { setToken } from "@/utils/auth";
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      // 切换酒店
      switchHotelDialogVisible: false,
      selectedHotelNo: ""
    };
  },
  computed: {
    ...mapGetters(["name", "sidebar", "avatar", "hotel_name", "account_list"]),
    // account_list 不为空数组就显示切换入口
    can_connect() {
      if (!this.account_list || !Array.isArray(this.account_list)) return 0;
      return this.account_list.length > 0 ? 1 : 0;
    },
    // 切换酒店弹窗用的酒店列表，直接取 store
    hotelList() {
      return this.account_list || [];
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },

    // 打开切换酒店弹窗
    openSwitchHotelDialog() {
      if (!this.hotelList || this.hotelList.length === 0) {
        this.$message.warning("暂无可切换的酒店账户");
        return;
      }
      const currentHotelNo =
        this.$store.getters.hotel_no || localStorage.getItem("hotel_no");
      // 确保当前酒店在 account_list 里，否则默认选第一个
      const exists = this.hotelList.some(h => h.hotel_no === currentHotelNo);
      this.selectedHotelNo = exists
        ? currentHotelNo
        : (this.hotelList[0] && this.hotelList[0].hotel_no) || "";
      this.switchHotelDialogVisible = true;
    },

    // 确认切换酒店
    async confirmSwitchHotel() {
      if (!this.selectedHotelNo) return;
      const target = this.hotelList.find(
        h => h.hotel_no === this.selectedHotelNo
      );
      if (!target) return;

      try {
        // 调后端切换接口，传 bind_id
        const res = await apiPostAdminAccountBindswitch({
          bind_id: target.bind_id
        });
        // 接口成功后重新存储 token + account_list，页面刷新后其他信息会自动重建
        const data = (res && res.data) || {};
        const newToken = data.token || res.token;
        if (newToken) {
          this.$store.commit("SET_TOKEN", newToken);
          setToken(newToken);
        }
        const newAccountList =
          (data.account_list && Array.isArray(data.account_list)
            ? data.account_list
            : null) ||
          (res.account_list && Array.isArray(res.account_list)
            ? res.account_list
            : null) ||
          [];

        // 如果接口返回了 switch_from（切换前的酒店信息），也 push 进 account_list，
        // 这样用户就可以从切换弹窗里切回原先的酒店
        const switchFrom = data.switch_from || res.switch_from || null;
        if (Array.isArray(switchFrom) && switchFrom.length > 0) {
          // 去重：已经在 account_list 里的酒店不重复 push
          const existsNos = new Set(newAccountList.map(a => a.hotel_no));
          switchFrom.forEach(item => {
            if (item && item.hotel_no && !existsNos.has(item.hotel_no)) {
              newAccountList.push(item);
              existsNos.add(item.hotel_no);
            }
          });
        } else if (switchFrom && switchFrom.hotel_no) {
          // 后端可能返回单个对象而不是数组
          const existsNos = new Set(newAccountList.map(a => a.hotel_no));
          if (!existsNos.has(switchFrom.hotel_no)) {
            newAccountList.push(switchFrom);
          }
        }

        localStorage.setItem("account_list", JSON.stringify(newAccountList));
        this.$store.commit("SET_ACCOUNT_LIST", newAccountList);

        this.switchHotelDialogVisible = false;
        this.$message({
          message: `已切换至「${target.hotel_name}」`,
          type: "success"
        });

        // 刷新页面使新 token + 新酒店配置生效
        setTimeout(() => {
          window.location.reload();
        }, 800);
      } catch (e) {
        // request 拦截器已经统一弹错误提示，这里只关闭弹窗即可
        this.switchHotelDialogVisible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    gap: 12px;

    &:focus {
      outline: none;
    }

    .hotel_name_style {
      color: #4a5565;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 12px;

      .hotel_name_style_left {
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .connect_list {
        display: flex;
        align-items: center;
        gap: 2px;
        color: #9ca3af;
        cursor: pointer;

        &:hover {
          color: #2563eb;
        }
      }
    }

    .line_style {
      width: 1px;
      height: 16px;
      background: #d8d8d8;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        // margin-top: 5px;
        display: flex;
        align-items: center;
        gap: 8px;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          font-size: 12px;
        }
      }
    }
  }
}

/* ============ 切换酒店弹窗 ============ */
::v-deep .switch_hotel_dialog {
  border-radius: 12px !important;
  overflow: hidden;
  padding-bottom: 0 !important;
}
::v-deep .switch_hotel_dialog .el-dialog__header {
  padding: 20px 24px 0 !important;
  margin: 0 !important;
}
::v-deep .switch_hotel_dialog .el-dialog__body {
  padding: 16px 24px !important;
  max-height: 60vh;
  overflow-y: auto;
}
::v-deep .switch_hotel_dialog .el-dialog__footer {
  padding: 12px 24px 20px !important;
  border-top: none;
}

.switch_hotel_dialog_title {
  text-align: left;
  .switch_hotel_dialog_title_main {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    line-height: 26px;
  }
  .switch_hotel_dialog_title_sub {
    font-size: 13px;
    color: #9ca3af;
    line-height: 20px;
    margin-top: 4px;
  }
}

.switch_hotel_list {
  max-height: 495px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  overflow-y: auto;
}

.switch_hotel_item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.18s ease;
  background: #ffffff;

  &:hover {
    border-color: #c7d2fe;
    background: #f8fafc;
  }

  &.switch_hotel_item_active {
    border-color: #2563eb;
    background: linear-gradient(
      90deg,
      rgba(37, 99, 235, 0.08) 0%,
      rgba(37, 99, 235, 0.02) 40%,
      #ffffff 100%
    );
    box-shadow: 0 2px 8px rgba(37, 99, 235, 0.08);

    .switch_hotel_item_icon {
      color: #2563eb;
      background: #dbeafe;
    }
    .switch_hotel_item_name {
      color: #1d4ed8;
    }
    .switch_hotel_item_addr {
      color: #60a5fa;
    }
  }
}

.switch_hotel_item_icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 20px;
  color: #6b7280;
  transition: all 0.18s ease;
}

.switch_hotel_item_info {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.switch_hotel_item_name {
  font-size: 15px;
  font-weight: bold;
  color: #1f2937;
  line-height: 22px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.switch_hotel_item_addr {
  font-size: 12px;
  color: #9ca3af;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.switch_hotel_item_check {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch_hotel_item_radio {
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 50%;
  background: #ffffff;
}

.switch_hotel_item_active .switch_hotel_item_check {
  background: #2563eb;
  border-radius: 50%;
  color: #ffffff;
  width: 20px;
  height: 20px;
  font-size: 13px;
}

.switch_hotel_dialog_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.switch_hotel_dialog_footer_tip {
  font-size: 12px;
  color: #9ca3af;
}

.switch_hotel_dialog_footer_btns {
  display: flex;
  gap: 10px;
}

.switch_hotel_btn_cancel {
  background: #ffffff !important;
  color: #6b7280 !important;
  border: 1px solid #d1d5db !important;
  border-radius: 6px !important;
  padding: 8px 20px !important;

  &:hover {
    border-color: #9ca3af !important;
    color: #374151 !important;
  }
}

.switch_hotel_btn_confirm {
  background: #2563eb !important;
  color: #ffffff !important;
  border: 1px solid #2563eb !important;
  border-radius: 6px !important;
  padding: 8px 20px !important;

  &:hover {
    background: #1d4ed8 !important;
    border-color: #1d4ed8 !important;
  }
  &:disabled {
    background: #93c5fd !important;
    border-color: #93c5fd !important;
  }
}

::v-deep .el-dropdown {
  display: inline-block;
  position: relative;
  color: #606266;
  font-size: 14px;
  flex-shrink: 0;
}
</style>
